import ds from './DataSourceService'

const baseUrl = '/menu-items'

const getMenuItemById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const updateMenuItemData = data => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + data.id, data)
}

const createMenuItem = data => {
  return ds.apiClientThinkHome.post(baseUrl, data)
}

const deleteMenuItem = id => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + id)
}
const getMenuItemTypes = menuItemId => {
  return ds.apiClientThinkHome.get(baseUrl + '/types')
}
const getMenuItemChildren = menuItemId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + menuItemId + '/children')
}
const updateMenuItemChildren = (children, menuItemId) => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + menuItemId + '/children', {
    children: children
  })
}

const getMenuItemTitle = menuItemId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + menuItemId + '/title')
}

const getMenuItemTitleByLanguage = (menuItemId, langId) => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/' + menuItemId + '/title?langId=' + langId
  )
}

// POIS
const getPoisForMenuItem = menuItemId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + menuItemId + '/pois')
}
const createPoiForMenuItem = (menuItemId, poi) => {
  return ds.apiClientThinkHome.post(baseUrl + '/' + menuItemId + '/pois', poi)
}
const updatePoiForMenuItem = (menuItemId, poi) => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + menuItemId + '/pois', poi)
}

const deletePoiForMenuItem = (menuItemId, poiId) => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + menuItemId + '/pois', {
    data: { poiId: poiId }
  })
}
const linkMenuItemWithPois = data => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + data.menuItemId + '/link-pois',
    {
      poiIds: data.poiIds
    }
  )
}
const removePoiForMenuItem = data => {
  return ds.apiClientThinkHome.del(
    baseUrl + '/' + data.menuItemId + '/remove-poi',
    {
      data: {
        poiId: data.poiId
      }
    }
  )
}

// MEDIA

const getMediaForMenuItem = menuItemId => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/' + menuItemId + '/media-content'
  )
}

const createMediaForMenuItem = (menuItemId, media) => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + menuItemId + '/media-content',
    media
  )
}
const updateMediaForMenuItem = (menuItemId, media) => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + menuItemId + '/media-content',
    media
  )
}

const deleteMediaForMenuItem = (menuItemId, mediaId) => {
  return ds.apiClientThinkHome.delete(
    baseUrl + '/' + menuItemId + '/media-content',
    {
      data: {
        mediaId: mediaId
      }
    }
  )
}

const linkMenuItemWithMedia = data => {
  return ds.apiClientThinkHome.post(
    baseUrl + '/' + data.menuItemId + '/link-media',
    {
      mediaIds: data.mediaIds
    }
  )
}

export default {
  getMenuItemChildren,
  getMenuItemById,
  getMenuItemTitle,
  getMenuItemTitleByLanguage,
  getPoisForMenuItem,
  createPoiForMenuItem,
  updatePoiForMenuItem,
  deletePoiForMenuItem,
  getMediaForMenuItem,
  createMediaForMenuItem,
  updateMediaForMenuItem,
  deleteMediaForMenuItem,
  updateMenuItemData,
  linkMenuItemWithPois,
  removePoiForMenuItem,
  linkMenuItemWithMedia,
  updateMenuItemChildren,
  createMenuItem,
  deleteMenuItem,
  getMenuItemTypes
}
